import React, { useEffect, useState } from "react";
import apiRoutes from "../../../api/apiRoutes"; 
import { appFetchJson } from "../../../utils/http"; 
import EessAutocomplete from "../../../components/autocomplete/EessAutocomplete";
import ProductoAutocomplete from "../../../components/autocomplete/ProductoAutocomplete";
import DrawerFilter from "../../../components/listing/DrawerFilter";
import InputNumberNoScroll from "../../../components/inputs/inputNumberNoScroll";

export default function FiltroPrecioProductoEess({
  initialFilters = {},
  onSubmit = () => {},
  onClose = () => {},
}) {
  // --- ESTADOS ---
  const [selectedEess, setSelectedEess] = useState(
    initialFilters.eessId
      ? { id: initialFilters.eessId, label: initialFilters.eessNombre || "Estación seleccionada" }
      : null
  );

  const [selectedProducto, setSelectedProducto] = useState(
    initialFilters.productoId
      ? { id: initialFilters.productoId, codigo: initialFilters.productoNombre || "Producto seleccionado" }
      : null
  );

  const [precio, setPrecio] = useState(initialFilters.precio || "");
  const [fecha, setFecha] = useState(initialFilters.fecha || "");
  const [estadoId, setEstadoId] = useState(initialFilters.estadoId || "");
  const [estados, setEstados] = useState([]);

  const [isSubmitting, setIsSubmitting] = useState(false);

  // --- CARGA DE CATÁLOGOS ---
  useEffect(() => {
    const cargarCatalogos = async () => {
      try {
        const resEst = await appFetchJson(apiRoutes.estado.listUrl({ page: 0, size: 100 }));
        const todosLosEstados = resEst?.items || [];
        setEstados(todosLosEstados.filter((e) => e.tipoId === 4));
      } catch (e) {
        console.error("Error cargando estados:", e);
      }
    };
    cargarCatalogos();
  }, []);

  // Helper para limpiar caracteres no numéricos
  const toNum = (val) => (val ? Number(val.toString().replace(/\D/g, "")) : null);

  // --- APLICAR FILTROS ---
  const handleApply = async () => {
    setIsSubmitting(true);
    // Simulación de carga (opcional)
    // await new Promise(resolve => setTimeout(resolve, 300));

    onSubmit({
      eessId: selectedEess?.id || null,
      productoId: selectedProducto?.id || null,
      eessNombre: selectedEess?.label || null,
      productoNombre: selectedProducto?.codigo || null,
      precio: toNum(precio),
      fecha: fecha || null,
      estadoId: estadoId || null,
    });
    
    setIsSubmitting(false);
    onClose();
  };

  return (
    <DrawerFilter
      title="Filtro Precio Producto por EE.SS."
      onClose={onClose}
      onApply={handleApply}
      isLoading={isSubmitting}
    >
      {/* 1. EE.SS. */}
      <div>
        <label className="form-label-fil">EE.SS.:</label>
        <div className="mt-1">
          <EessAutocomplete
            value={selectedEess}
            onChange={setSelectedEess}
            placeholder="Buscar estación..."
            className="w-full"
          />
        </div>
      </div>

      {/* 2. Producto */}
      <div>
        <label className="form-label-fil">Producto:</label>
        <div className="mt-1">
          <ProductoAutocomplete
            value={selectedProducto}
            onChange={setSelectedProducto}
            placeholder="Buscar producto..."
            className="w-full"
          />
        </div>
      </div>

     {/* 3. Precio */}
      <div>
        <label className="form-label-fil">Valor Precio:</label>
        <InputNumberNoScroll
          className="input mt-1 w-full"
          value={precio}
          onChange={(e) => setPrecio(e.target.value)}
          placeholder="Ej: 5000"
          inputMode="numeric"
        />
        <p className="text-xs text-gray-400 mt-1">
          Se eliminan puntos y caracteres especiales al filtrar.
        </p>
      </div>

      {/* 4. Fecha */}
      <div>
        <label className="form-label-fil">Fecha:</label>
        <input
          type="date"
          className="input mt-1 w-full"
          value={fecha}
          onChange={(e) => setFecha(e.target.value)}
        />
      </div>

      {/* 5. Estado */}
      <div>
        <label className="form-label-fil">Estado:</label>
        <select
          className="input mt-1 w-full"
          value={estadoId}
          onChange={(e) => setEstadoId(e.target.value)}
        >
          <option value="">-- Todos --</option>
          {estados.map((opt) => (
            <option key={opt.id} value={opt.id}>
              {opt.nombre}
            </option>
          ))}
        </select>
      </div>

    </DrawerFilter>
  );
}